<div class="form-field-container label-{{ labelDirection }}" [ngClass]="containerClass">
	@if (label) {
		<div class="label {{ labelClass }}" [matTooltip]="labelTooltip">
			<label>{{ label }}</label>
		</div>
	}

	<div class="element">
		<ng-content />
	</div>
</div>

@if (!warningMessageHidden && warningMessage && warningMessage.length) {
	<div class="error-container">
		<div class="error error--warning">
			<mat-icon class="error__icon" svgIcon="ic-warning-info" />
			<span class="error__text">{{ warningMessage }}</span>
		</div>
	</div>
}

@if (!errorMessageHidden && formControl?.invalid) {
	<div class="error-container">
		<div class="error">
			@if (errorsWithIconTemplate) {
				<ng-container
					[ngTemplateOutlet]="errorsWithIconTemplate"
					[ngTemplateOutletContext]="{ errors: formControl?.errors }"
				/>
			} @else {
				<mat-icon class="error__icon" svgIcon="ic-close-small" />

				@if (!errorsTemplate && errorMessage) {
					<span class="error__text">{{ errorMessage }}</span>
				} @else {
					<span class="error__text">
						<ng-container
							[ngTemplateOutlet]="errorsTemplate"
							[ngTemplateOutletContext]="{ errors: formControl?.errors }"
						/>
					</span>
				}
			}
		</div>
	</div>
}
